import { ApiError, apiFetch } from '@/lib/api/client'

export interface AuthUser {
  id: string
  displayName: string
  email?: string
}

export interface AuthApi {
  login(password: string): Promise<AuthUser>
  logout(): Promise<void>
  me(): Promise<AuthUser | null>
}

class HttpAuthApi implements AuthApi {
  async login(password: string): Promise<AuthUser> {
    const body = await apiFetch<{ user_id: string; display_name: string }>('/api/v1/auth/login', {
      method: 'POST',
      body: JSON.stringify({ password }),
    })

    return {
      id: body.user_id,
      displayName: body.display_name,
    }
  }

  async logout(): Promise<void> {
    await apiFetch<void>('/api/v1/auth/logout', { method: 'POST' })
  }

  async me(): Promise<AuthUser | null> {
    try {
      const body = await apiFetch<{ id: string; display_name: string; email?: string }>(
        '/api/v1/auth/me',
      )
      return {
        id: body.id,
        displayName: body.display_name,
        email: body.email,
      }
    } catch (error) {
      if (error instanceof ApiError && error.status === 401) {
        return null
      }
      throw error
    }
  }
}

export const authApi = new HttpAuthApi()
